import axios from "axios";

// PDFs and invoice images are rendered on the server, which has no idea what
// timezone the person downloading them is in. Every request carries the
// browser's IANA zone (e.g. "Asia/Kolkata") so the server can print dates and
// times the way this user sees them - see server/documents/_time.js.
export const browserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "";
  } catch (error) {
    return "";
  }
};

export const attachTimeZone = (instance) => {
  instance.interceptors.request.use((config) => {
    const timeZone = browserTimeZone();
    if (timeZone) {
      config.headers = config.headers || {};
      config.headers["X-Timezone"] = timeZone;
    }
    return config;
  });
};

// Most PDF/PNG download calls use the global axios directly.
attachTimeZone(axios);
